import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import { ContactListModel } from '../../../model/block';
import styled, { ThemeProvider } from 'styled-components';
import { inject } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { findLinkedData } from '../../../util/page/find-linked-data.util';
import {
  COMPACT_CONTACT_CARD_HORIZONTAL_MARGIN,
  COMPACT_CONTACT_CARD_WIDTH,
  compactStyle,
  ContactCard
} from '../../contact-card/contact-card';
import { largeMobileMedia } from '../../../util/style/large-mobile-media';
import { LinkedDataModel } from '../../../model/linked-data/linked-data.model';
import { ContactListLinkedDataModel, ISingleContactItemData } from '../../../model/linked-data';
import { DesignObjectMentionMetadataType } from '../../../enum/page-mention-metadata-type.enum';
import Translate from '../../translate/translate';

const CONTACT_LIST_HORIZONTAL_PADDING = 40;

interface IContactListWrapper {
  topBottomPadding: number;
}

const ContactListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: ${(props: IContactListWrapper) => props.topBottomPadding}px ${CONTACT_LIST_HORIZONTAL_PADDING}px;
  width: 100%;
  margin: 0 auto;
  ${compactStyle(`
    max-width: ${COMPACT_CONTACT_CARD_WIDTH * 4 + 4 * 2 * COMPACT_CONTACT_CARD_HORIZONTAL_MARGIN + 2 * CONTACT_LIST_HORIZONTAL_PADDING}px;
    align-items: center;
    justify-contect: center;
  `)}
  ${largeMobileMedia(`
    flex-direction: column;
    padding: 40px 0;
  `)}
`;

function isContactData(data: LinkedDataModel): data is ContactListLinkedDataModel {
  return data && data.type === DesignObjectMentionMetadataType.ContactsList;
}

@inject('state', 'history')
export class ContactListView extends BaseBlockView<ContactListModel, IInjectedProps> {
  renderContactList = (listData: ISingleContactItemData[]) => {
    return <ThemeProvider theme={{_ContactIsCompact: listData.length > 2}}>
      <ContactListWrapper topBottomPadding={this.props.content.topBottomPadding}>
        {listData.map((item, index: number) => <ContactCard
          key={index}
          item={item}
          contact={this.props.content}
          socialButtonTextColor={this.props.content.socialButtonsTextColor}
          socialButtonBackgroundColor={this.props.content.socialButtonsBackgroundColor}
          backgroundColor={this.props.backgroundColor}
        />)}
      </ContactListWrapper>
    </ThemeProvider>;
  }

  render() {
    if (this.props.inEditor) {
      return !this.props.content.selectedMention ?
        <Translate>contact-list.edit.placeholder</Translate> : this.renderContactList([ {
          email: 'example@email.com',
          image: 'https://getuikit.com/v2/docs/images/placeholder_200x100.svg',
          linkedInUrl: 'http://linkedin.com',
          location: 'Stockholm',
          name: 'Example Person',
          phone: undefined,
          title: 'Example Job Title'
        } ]);
    }
    const selectedMention = this.props.content.selectedMention;
    const foundData = findLinkedData(selectedMention, this.props.state.activeDesign.data);
    if (isContactData(foundData)) {
      const listData = foundData.data;
      return this.renderContactList(listData);
    } else {
      return null;
    }
  }
}
